import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getWorkflowAutomationAvailability } from '@ebalance/proto/bffuser/v1/workflow_automation_service-WorkflowAutomationService_connectquery'
import {
  GetWorkflowAutomationAvailabilityRequestSchema,
  type GetWorkflowAutomationAvailabilityResponse,
} from '@ebalance/proto/bffuser/v1/workflow_automation_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

const REQUEST = create(GetWorkflowAutomationAvailabilityRequestSchema, {})

/** The release decision is fail-closed until this mount has fetched it. */
export function useWorkflowAutomationAvailability(): UseQueryResult<
  GetWorkflowAutomationAvailabilityResponse,
  ConnectError
> {
  return useQuery(getWorkflowAutomationAvailability, REQUEST, {
    throwOnError: false,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  })
}

export function isWorkflowAutomationAvailable(
  result: UseQueryResult<
    GetWorkflowAutomationAvailabilityResponse,
    ConnectError
  >,
): boolean {
  return (
    result.isFetchedAfterMount &&
    !result.isFetching &&
    !result.isError &&
    result.data?.featureEnabled === true
  )
}
